import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  // holds counts per scope, e.g. { login: 0, me: 1 }
  private readonly _counts = signal<Record<string, number>>({});

  /** Increment loading count for a scope */
  inc(scope: string) {
    this._counts.update((m) => ({
      ...m,
      [scope]: Math.max(0, (m[scope] ?? 0) + 1),
    }));
  }

  /** Decrement loading count for a scope */
  dec(scope: string) {
    this._counts.update((m) => {
      const next = (m[scope] ?? 0) - 1;
      return { ...m, [scope]: Math.max(0, next) };
    });
  }

  /** Clear a scope (force to 0) */
  clear(scope: string) {
    this._counts.update((m) => ({ ...m, [scope]: 0 }));
  }

  /** Readonly signal: true if scope is loading (>0) */
  signalFor(scope: string) {
    return computed(() => (this._counts()[scope] ?? 0) > 0);
  }
}
